// src/pages/properties/components/PropertyPhotoManager.tsx
import {useState} from "react";
import {Image as ImageIcon, Upload, Grid3X3} from "lucide-react";
import {Button} from "../../../components/ui";
import {useModal} from "../../../hooks/common/useModal";
import {Modal} from "../../../components/ui";

import type {PropertyResponseDto} from "../../../types/property";
import PropertyPhotoGallery from "./PropertyPhotoGallery";

interface PropertyPhotoManagerProps {
  property: PropertyResponseDto;
}

const PropertyPhotoManager: React.FC<PropertyPhotoManagerProps> = ({
  property,
}) => {
  const photoModal = useModal("property-photos");
  const photos = property.photos || [];

  return (
    <div className="space-y-4">
      {/* Current Photos Preview */}
      {photos.length > 0 ? (
        <div className="grid grid-cols-4 gap-3">
          {photos.slice(0, 4).map((photo) => (
            <div
              key={photo.id}
              className="aspect-square rounded-lg overflow-hidden bg-gray-100 dark:bg-dark-700 relative"
            >
              <img
                src={photo.photoUrl}
                alt=""
                className="w-full h-full object-cover"
              />
              {photo.isPrimary && (
                <div className="absolute top-1 left-1">
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
                    Primary
                  </span>
                </div>
              )}
            </div>
          ))}

          {photos.length > 4 && (
            <div className="aspect-square rounded-lg bg-gray-100 dark:bg-dark-700 flex items-center justify-center">
              <div className="text-center">
                <Grid3X3 className="w-6 h-6 text-gray-400 mx-auto mb-1" />
                <span className="text-xs text-gray-500">
                  +{photos.length - 4} more
                </span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="border-2 border-dashed border-gray-300 dark:border-dark-600 rounded-lg p-8 text-center">
          <ImageIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500 dark:text-gray-400 mb-2">
            No photos uploaded
          </p>
          <p className="text-sm text-gray-400 dark:text-gray-500">
            Add photos to showcase this property
          </p>
        </div>
      )}

      {/* Manage Photos Button */}
      <Button variant="outline" onClick={photoModal.open} className="w-full">
        <Upload className="w-4 h-4 mr-2" />
        Manage Photos ({property.photoCount})
      </Button>

      {/* Photo Management Modal */}
      <Modal
        isOpen={photoModal.isOpen}
        onClose={photoModal.close}
        title=""
        size="xl"
      >
        {/* ✅ RTK Query cache invalidation သာ အားကိုးတယ် */}
        <PropertyPhotoGallery property={property} onClose={photoModal.close} />
      </Modal>
    </div>
  );
};

export default PropertyPhotoManager;
